import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";
import { Apple, Heart } from "react-bootstrap-icons";
import { FaCarrot } from "react-icons/fa";
import { RiNumber1 , RiNumber2, RiNumber3,RiNumber4 } from "react-icons/ri";

import { Star } from "react-bootstrap-icons"; // example icons
import Header1 from "./Header1";
import Footer from "./Footer";

const About = () => {
  const features = [

  {
    icon: (
      // Apple + carrot combined icon doesn't exist; using Apple here as placeholder
      <Apple className="text-success" size={30} />
    ),
    title: "Pesticide Free Goods",
    description:
      "There are many variations of passages of any Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or mori words....",
  },
  {
    icon: <Heart className="text-success" size={30} />, // Substitute for carrot + apple icon combo
    title: "Curated Products",
    description:
      "There are many variations of passages of any Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or mori words....",
  },
   {
    icon: < FaCarrot className="text-success" size={30} />, // Substitute for carrot + apple icon combo
    title: "Curated Products",
    description:
      "There are many variations of passages of any Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or mori words....",
  },
];

const features1 = [
  {
    icon: <RiNumber1 className="text-success" size={30} />,
    title: "Download the App",
    description:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    icon: <RiNumber2 className="text-success" size={30} />,
    title: "Add to cart",
    description:
      "Fresh and healthy produce free from harmful pesticides for your family's safety.",
  },
  {
    icon: < RiNumber3 className="text-success" size={30} />,
    title: "Payment your bill",
    description:
      "Handpicked products with quality and taste in mind for the best experience.",
  },
  {
    icon: <RiNumber4 className="text-success" size={30} />,
    title: "Received your item",
    description:
      "Organic, farm-fresh items delivered straight to your home with care.",
  },
];
 
  return (
    <>
      <Header1 />

      <div
        className="d-flex flex-column justify-content-center align-items-center text-center position-relative"
        style={{
          height: '400px',
          color: 'white',
          overflow: 'hidden',
          padding: '0 20px', // horizontal padding
        }}
      >
        {/* Background image overlay with reduced opacity */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url('https://plus.unsplash.com/premium_photo-1664527305901-a3c8bec62850')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.4, // reduce opacity
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />

        {/* Content above the overlay */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 className="fw-bold text-black">About Us</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ backgroundColor: 'transparent', paddingLeft: 0, marginBottom: 0 }}>
              <li className="breadcrumb-item">
                <a href="/" className="text-black text-decoration-none">
                  <i className="bi bi-house-fill "></i> Home
                </a>
              </li>
              <li className="breadcrumb-item active text-black" aria-current="page">
                About
              </li>
            </ol>
          </nav>
        </div>
      </div>

          <section className="py-5">
  <Container>
    <Row className="align-items-center">

      {/* Left Image */}
      <Col lg={6} className="position-relative mb-4 mb-lg-0 d-flex justify-content-center">
        
        <div
          className="rounded-circle overflow-hidden"
          style={{ width: "420px", height: "420px" }}
        >
          <img
            src="https://plus.unsplash.com/premium_photo-1722073663754-c47eff499093?q=80&w=1479&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Organic Vegetables"
            className="img-fluid w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Quote Box */}
        <div
          className="position-absolute bg-success text-white p-4 shadow"
          style={{ bottom: "0", left: "10%" }}
        >
          <p className="fst-italic mb-2">
            “The product is always fresh and high quality, and the app is simple to use, making grocery shopping a breeze.”
          </p>
          <strong>— sameer singh</strong>
        </div>

      </Col>

      {/* Right Content */}
      <Col lg={6}>
        <span className="text-danger fw-semibold d-block mb-2">
          About Us
        </span>

        <h2 className="fw-bold mb-3">
          Welcome To Organic Agriculture Grocery Shop
        </h2>

        <p className="text-secondary mb-4">
          There are many variations of passages of Lorem Ipsum available,
          but the majority have suffered alteration in some form, by
          injected humour, or more words which slightly believable.
        </p>

        <Row>
          {[
            "Organic products who are so",
            "Healthy food everyday",
            "Local growth of fresh food",
            "Demoralized charms of pleasure",
          ].map((text, index) => (
            <Col sm={6} className="d-flex align-items-center mb-3" key={index}>
              <div
                className="border border-success text-success rounded-circle d-flex align-items-center justify-content-center fw-semibold me-3"
                style={{ width: "40px", height: "40px" }}
              >
                {String(index + 1).padStart(2, "0")}
              </div>
              <h6 className="mb-0">{text}</h6>
            </Col>
          ))}
        </Row>

      </Col>

    </Row>
  </Container>
</section>

 <section style={{ backgroundColor: "#faf0e6" }} className="py-5">
      <Container>
        <p className="text-danger fw-bold small fst-italic mb-2 text-center">
          Our Features
        </p>
        <h2 className="fw-bold mb-5 text-center">Why Choose Us</h2>

        <Row>
          {features.map(({ icon, title, description }, idx) => (
            <Col md={4} key={idx} className="mb-4">
              <div className="bg-white p-4 h-100 shadow-sm">
                <div className="mb-3">{icon}</div>
                <h5 className="fw-bold">{title}</h5>
                <p className="text-muted">{description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
    <section  style={{ backgroundColor: "#eee8e2" }} className="py-5">
      <Container>

           <p className="text-danger fw-bold small fst-italic mb-2 text-center">
          how we work
        </p>
        <h2 className="fw-bold mb-5 text-center">Our working process</h2>
   <Row>
      {features1.map(({ icon, title, description }, idx) => (
        <Col md={3} key={idx} className="mb-4">
          <div className="bg-white p-4 h-100 shadow-sm text-center">
            <div className="mb-3">{icon}</div>
            <h5 className="fw-bold">{title}</h5>
            <p className="text-muted">{description}</p>
          </div>
        </Col>
      ))}
    </Row>

        </Container>

    </section>
    

    <Footer/>

    </>
  );
};

export default About;
